module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAApCAYAAADTRMI6AAAAAXNSR0IArs4c6QAAATJJREFUSEvtljFKxUAURc9FsBLEXkGxs7Syk4+NYKGljZ2l4ArU7wLcg/ArO93Bx8ZVCBYuQMHO4smEjIzJm8kPtjNdkvdOTob7wojCMrNV4FzSXalOA5Bb4BJYl/SVq81CWot3YAWYSgpAd5Ugoem67fos2biQjkV8e9YmB0ktIiRr04NkLIo2HsSzKNr8gQxYZG26kJJF1uYXsqCFa5NCFrFwbRrISIueTYRMgZvSHDnPPoCNMFNyLF6BGXAI7CXNV8AucAQst/ebFAdI2IsL4CE0S3ppP3EO7CeQiaS5ma0Bp8AZsNPMlJkdAM+SvlNlM3MhnZptYKk0xYOQCKyQfmLqntQ96U6x98+pOak5+W9OHoHjBLIl6W1s2E6AeyAcQ58khetxB79YbWabOYNY8wNKb+ZWhkuT7gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/top.png
// module id = Uw9C
// module chunks = 1